module.exports = __webpack_public_path__ + "img/ic-menu-more-closed.c6dd6514.svg";